import React, { useState, useEffect } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";
import { togglePrintingPreference, getUserPreference } from "../../../api/api";
import { set } from "react-hook-form";
import { IconButton } from "@mui/material";
import { FaBackspace } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import { Toaster, toast } from "react-hot-toast";

const PrintingPreference = ({ handleSettingSwitch }) => {
  //Configuration for paragraph
  const initialText =
    "This features enables printing order packing list, shipping label and return label in one click or saperately with saveral clicks";

  const [showFullText, setShowFullText] = useState(
    window.innerWidth > 768 // Show full text by default on larger screens
  );
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth <= 768
  );

  const handleToggleText = () => {
    setShowFullText(!showFullText);
  };

  const handleResize = () => {
    const isMobileOrTabletNow = window.innerWidth <= 768;
    setIsMobileOrTablet(isMobileOrTabletNow);

    // Adjust showFullText based on screen size change
    if (isMobileOrTablet !== isMobileOrTabletNow) {
      setShowFullText(!isMobileOrTabletNow);
    }
  };

  useEffect(async () => {
    
   if(localStorage.getItem("roleId") === 1)
   {
    
    var response = await getUserPreference();
    
    if (response) 
    {
        
        setPrintingPreference(response.data.printAllLabelsAtOnce);
        
    }
   }
   else
   {
    
     if(localStorage.getItem("printAllLabelsAtOnce") === null)
     {
        var response = await getUserPreference();
    
            if (response) 
            {
                
                setPrintingPreference(response.data.printAllLabelsAtOnce);
                
            }

     }
     else
     {
        setPrintingPreference(JSON.parse(localStorage.getItem("printAllLabelsAtOnce")));
     }
   }
    setLoading(false);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobileOrTablet]);


  

  
  const [loading, setLoading] = useState(true);
  const [printingPreference, setPrintingPreference] = useState(false);
 
  const handleToggle = async () => {
    try {
      let targetValue = !printingPreference;
      setLoading(true);
      const response = await togglePrintingPreference(
        JSON.stringify({
            printAllLabelsAtOnce: targetValue,
        })
      );

      if (response) {
        setPrintingPreference(targetValue);
        localStorage.setItem("printAllLabelsAtOnce", targetValue);

        if (targetValue) {
          toast.success("Your preference to print all labels at once has been updated");
        } else {
          toast.success("Your preference to print labels one at a time has been updated");
        }
      } else {
        console.error("API call failed");
      }
    } catch (error) {
      
      toast.error("Could not complete request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabPanelCls h-100">
      <Toaster />
      <div
        className="dispatchTimer"
        style={{ position: "relative", marginTop: "20px" }}
      >
        <div
          style={{
            position: "fixed",
            width: "100%",
            background: "white",
            marginTop: "10px",
          }}
        >
          <div className="header">
            <div style={{ marginBottom: 20 }}>
              <h2 className="ruby center">
                <IconButton onClick={() => handleSettingSwitch("")}>
                  <FaBackspace />
                </IconButton>
                Printing Preference
              </h2>
            </div>
            <p style={{ maxWidth: "70vw" }}>
              {showFullText ? initialText : `${initialText.slice(0, 100)}... `}
              {isMobileOrTablet && (
                <span
                  style={{
                    color: "grey",
                    cursor: "pointer",
                    marginLeft: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    marginTop: 5,
                  }}
                  onClick={handleToggleText}
                >
                  {showFullText ? "Read less" : "Read more"}
                  {showFullText ? <FaAngleUp /> : <FaAngleDown />}
                </span>
              )}
            </p>
          </div>

          <FormGroup>
            <FormControlLabel
              control={
                loading ? (
                  <CircularProgress
                    style={{ marginRight: 10 }}
                    size={24}
                    color="secondary"
                  />
                ) : (
                  <Switch
                    color="success"
                    checked={printingPreference}
                    onChange={handleToggle}
                  />
                )
              }
              label="Print Labels in One Click"
              style={{ marginLeft: 10, marginTop: 40 }}
            />
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default PrintingPreference;
